import * as React from 'react';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import useAppRouter from '@hooks/useAppRouter';
import useDeviceStore from '@hooks/useDeviceStore';
import RedDot from '@components/common/RedDot';
import Icon from '@src/svg/Icon';

const RedDotWrap = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

const PushAndSettingIconButtons = (): React.ReactElement => {
  const router = useAppRouter();

  const [state] = useDeviceStore();
  const [isApp, setApp] = useState(false);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setApp(!!state?.deviceId);
    }
  }, [state?.deviceId]);

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
      {router.pathname === '/ranking' && (
        <Icon
          name="search"
          onClick={() => router.push('/ranking/search')}
          width={24}
          height={24}
        />
      )}
      {isApp && (
        <RedDotWrap>
          <Icon
            name="push"
            width={24}
            height={24}
            onClick={() => router.push('/push-history')}
          />
          <RedDot />
        </RedDotWrap>
      )}
      <Icon
        name="setting"
        onClick={() => router.push('/setting')}
        width={24}
        height={24}
      />
    </div>
  );
};

export default PushAndSettingIconButtons;
